import React, { Component } from 'react';
import { LeftSider, RightPanels } from '../components/index';

class ReportSetup extends Component {
  componentDidMount() { }

  render() {
    return (
      <div>
        <LeftSider />
        <RightPanels />
      </div>
    );
  }
}

export default ReportSetup;



// WEBPACK FOOTER //
// ./src/views/ReportSetup/container/index.jsx